export const SEND_FORM_PRINT_REQUEST = 'SEND_FORM_PRINT_REQUEST';
export const SEND_FORM_PRINT_RESPONSE = 'SEND_FORM_PRINT_RESPONSE';
export const SEND_FORM_PRINT_FAILURE = 'SEND_FORM_PRINT_FAILURE';
export const GET_FORM_PRINTS_REQUEST = 'GET_FORM_PRINTS_REQUEST';
export const GET_FORM_PRINTS_RESPONSE = 'GET_FORM_PRINTS_RESPONSE';
export const GET_FORM_PRINTS_FAILURE = 'GET_FORM_PRINTS_FAILURE';
